import type { BrewingMethod } from '@/types/grinder';

/**
 * Standard brewing methods with their micron ranges and visual layout levels.
 * This data is constant across all grinders.
 */
export const BREWING_METHODS: BrewingMethod[] = [
  {
    label: "Turkish",
    min: 40,
    max: 220,
    level: 1
  },
  {
    label: "Espresso",
    min: 180,
    max: 380,
    level: 0
  },
  {
    label: "V60",
    min: 400,
    max: 700,
    level: 0
  },
  {
    label: "Aeropress",
    min: 320,
    max: 960,
    level: 2
  },
  {
    label: "Moka Pot",
    min: 360,
    max: 660,
    level: 1
  },
  {
    label: "Pour Over",
    min: 410,
    max: 930,
    level: 3
  },
  {
    label: "Siphon",
    min: 375,
    max: 800,
    level: 4
  },
  {
    label: "Filter Coffee Machine",
    min: 300,
    max: 900,
    level: 6
  },
  {
    label: "French Press",
    min: 690,
    max: 1300,
    level: 1
  },
  {
    label: "Cupping",
    min: 460,
    max: 850,
    level: 7
  },
  {
    label: "Cold Brew",
    min: 800,
    max: 1440,
    level: 0
  },
  {
    label: "Cold Drip",
    min: 820,
    max: 1270,
    level: 4
  },
  {
    label: "Steep-and-release",
    min: 450,
    max: 825,
    level: 5
  }
];
